/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * aim-app/auth API
 * カスタマーの初回の作成およびカスタマー情報の設定、オペレーターのログイン、ログアウトを行う機能を提供します。
 * OpenAPI spec version: 2.0
 */
import useSwr from 'swr';
import type { Key, SWRConfiguration } from 'swr';

import useSWRMutation from 'swr/mutation';
import type { SWRMutationConfiguration } from 'swr/mutation';

import type {
  GetAdminTenantsParams,
  GetAdminTenantsTenantIdProjectsParams,
  GetAdminUsersParams,
  PostAdminTenantsBody,
  PostAdminTenantsTenantIdInviteSelfUserBody,
  PostAdminTenantsTenantIdProjectsBody,
  PostAdminUsersBody,
  ResponseAdminTenantsGet,
  ResponseAdminTenantsPost,
  ResponseAdminTenantsTenantIdInviteSelfUserPost,
  ResponseAdminTenantsTenantIdProjectsGet,
  ResponseAdminUsersGet,
  ResponseAdminUsersPost,
} from '.././model';

import { customInstance } from '../../lib/axios';
import type { ErrorType, BodyType } from '../../lib/axios';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 検索条件に紐づくTenant情報の一覧を返します。
 */
export const getAdminTenants = (
  params: GetAdminTenantsParams,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<ResponseAdminTenantsGet>(
    { url: `/admin/tenants`, method: 'GET', params },
    options
  );
};

export const getGetAdminTenantsKey = (params: GetAdminTenantsParams) =>
  [`/admin/tenants`, ...(params ? [params] : [])] as const;

export type GetAdminTenantsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminTenants>>>;
export type GetAdminTenantsQueryError = ErrorType<unknown>;

export const useGetAdminTenants = <TError = ErrorType<unknown>>(
  params: GetAdminTenantsParams,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getAdminTenants>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetAdminTenantsKey(params) : null));
  const swrFn = () => getAdminTenants(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};
/**
 * Tenantを新規作成する。
 */
export const postAdminTenants = (
  postAdminTenantsBody: BodyType<PostAdminTenantsBody>,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<ResponseAdminTenantsPost>(
    {
      url: `/admin/tenants`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postAdminTenantsBody,
    },
    options
  );
};

export const getPostAdminTenantsMutationFetcher = (
  options?: SecondParameter<typeof customInstance>
) => {
  return (_: Key, { arg }: { arg: PostAdminTenantsBody }): Promise<ResponseAdminTenantsPost> => {
    return postAdminTenants(arg, options);
  };
};
export const getPostAdminTenantsMutationKey = () => [`/admin/tenants`] as const;

export type PostAdminTenantsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAdminTenants>>
>;
export type PostAdminTenantsMutationError = ErrorType<unknown>;

export const usePostAdminTenants = <TError = ErrorType<unknown>>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof postAdminTenants>>,
    TError,
    Key,
    PostAdminTenantsBody,
    Awaited<ReturnType<typeof postAdminTenants>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getPostAdminTenantsMutationKey();
  const swrFn = getPostAdminTenantsMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};
/**
 * 検索条件に紐づくProject情報の一覧を返します。
 */
export const getAdminTenantsTenantIdProjects = (
  tenantId: string,
  params: GetAdminTenantsTenantIdProjectsParams,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<ResponseAdminTenantsTenantIdProjectsGet>(
    { url: `/admin/tenants/${tenantId}/projects`, method: 'GET', params },
    options
  );
};

export const getGetAdminTenantsTenantIdProjectsKey = (
  tenantId: string,
  params: GetAdminTenantsTenantIdProjectsParams
) => [`/admin/tenants/${tenantId}/projects`, ...(params ? [params] : [])] as const;

export type GetAdminTenantsTenantIdProjectsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminTenantsTenantIdProjects>>
>;
export type GetAdminTenantsTenantIdProjectsQueryError = ErrorType<unknown>;

export const useGetAdminTenantsTenantIdProjects = <TError = ErrorType<unknown>>(
  tenantId: string,
  params: GetAdminTenantsTenantIdProjectsParams,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getAdminTenantsTenantIdProjects>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!tenantId;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetAdminTenantsTenantIdProjectsKey(tenantId, params) : null));
  const swrFn = () => getAdminTenantsTenantIdProjects(tenantId, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};
/**
 * Projectを新規作成する。
 */
export const postAdminTenantsTenantIdProjects = (
  tenantId: string,
  postAdminTenantsTenantIdProjectsBody: BodyType<PostAdminTenantsTenantIdProjectsBody>,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<ResponseAdminTenantsTenantIdProjectsGet>(
    {
      url: `/admin/tenants/${tenantId}/projects`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postAdminTenantsTenantIdProjectsBody,
    },
    options
  );
};

export const getPostAdminTenantsTenantIdProjectsMutationFetcher = (
  tenantId: string,
  options?: SecondParameter<typeof customInstance>
) => {
  return (
    _: Key,
    { arg }: { arg: PostAdminTenantsTenantIdProjectsBody }
  ): Promise<ResponseAdminTenantsTenantIdProjectsGet> => {
    return postAdminTenantsTenantIdProjects(tenantId, arg, options);
  };
};
export const getPostAdminTenantsTenantIdProjectsMutationKey = (tenantId: string) =>
  [`/admin/tenants/${tenantId}/projects`] as const;

export type PostAdminTenantsTenantIdProjectsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAdminTenantsTenantIdProjects>>
>;
export type PostAdminTenantsTenantIdProjectsMutationError = ErrorType<unknown>;

export const usePostAdminTenantsTenantIdProjects = <TError = ErrorType<unknown>>(
  tenantId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof postAdminTenantsTenantIdProjects>>,
      TError,
      Key,
      PostAdminTenantsTenantIdProjectsBody,
      Awaited<ReturnType<typeof postAdminTenantsTenantIdProjects>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getPostAdminTenantsTenantIdProjectsMutationKey(tenantId);
  const swrFn = getPostAdminTenantsTenantIdProjectsMutationFetcher(tenantId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};
/**
 * Projectに紐づくUserを招待する。
 */
export const postAdminTenantsTenantIdInviteSelfUser = (
  tenantId: string,
  postAdminTenantsTenantIdInviteSelfUserBody: BodyType<PostAdminTenantsTenantIdInviteSelfUserBody>,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<ResponseAdminTenantsTenantIdInviteSelfUserPost>(
    {
      url: `/admin/tenants/${tenantId}/invite_self_user`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postAdminTenantsTenantIdInviteSelfUserBody,
    },
    options
  );
};

export const getPostAdminTenantsTenantIdInviteSelfUserMutationFetcher = (
  tenantId: string,
  options?: SecondParameter<typeof customInstance>
) => {
  return (
    _: Key,
    { arg }: { arg: PostAdminTenantsTenantIdInviteSelfUserBody }
  ): Promise<ResponseAdminTenantsTenantIdInviteSelfUserPost> => {
    return postAdminTenantsTenantIdInviteSelfUser(tenantId, arg, options);
  };
};
export const getPostAdminTenantsTenantIdInviteSelfUserMutationKey = (tenantId: string) =>
  [`/admin/tenants/${tenantId}/invite_self_user`] as const;

export type PostAdminTenantsTenantIdInviteSelfUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAdminTenantsTenantIdInviteSelfUser>>
>;
export type PostAdminTenantsTenantIdInviteSelfUserMutationError = ErrorType<unknown>;

export const usePostAdminTenantsTenantIdInviteSelfUser = <TError = ErrorType<unknown>>(
  tenantId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof postAdminTenantsTenantIdInviteSelfUser>>,
      TError,
      Key,
      PostAdminTenantsTenantIdInviteSelfUserBody,
      Awaited<ReturnType<typeof postAdminTenantsTenantIdInviteSelfUser>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ?? getPostAdminTenantsTenantIdInviteSelfUserMutationKey(tenantId);
  const swrFn = getPostAdminTenantsTenantIdInviteSelfUserMutationFetcher(tenantId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};
/**
 * 検索条件に紐づくUser情報の一覧を返します。
 */
export const getAdminUsers = (
  params: GetAdminUsersParams,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<ResponseAdminUsersGet>(
    { url: `/admin/users`, method: 'GET', params },
    options
  );
};

export const getGetAdminUsersKey = (params: GetAdminUsersParams) =>
  [`/admin/users`, ...(params ? [params] : [])] as const;

export type GetAdminUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminUsers>>>;
export type GetAdminUsersQueryError = ErrorType<unknown>;

export const useGetAdminUsers = <TError = ErrorType<unknown>>(
  params: GetAdminUsersParams,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getAdminUsers>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetAdminUsersKey(params) : null));
  const swrFn = () => getAdminUsers(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};
/**
 * Userを新規作成する。
 */
export const postAdminUsers = (
  postAdminUsersBody: BodyType<PostAdminUsersBody>,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<ResponseAdminUsersPost>(
    {
      url: `/admin/users`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postAdminUsersBody,
    },
    options
  );
};

export const getPostAdminUsersMutationFetcher = (
  options?: SecondParameter<typeof customInstance>
) => {
  return (_: Key, { arg }: { arg: PostAdminUsersBody }): Promise<ResponseAdminUsersPost> => {
    return postAdminUsers(arg, options);
  };
};
export const getPostAdminUsersMutationKey = () => [`/admin/users`] as const;

export type PostAdminUsersMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminUsers>>>;
export type PostAdminUsersMutationError = ErrorType<unknown>;

export const usePostAdminUsers = <TError = ErrorType<unknown>>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof postAdminUsers>>,
    TError,
    Key,
    PostAdminUsersBody,
    Awaited<ReturnType<typeof postAdminUsers>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getPostAdminUsersMutationKey();
  const swrFn = getPostAdminUsersMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};
